var map = {
	"./adobeXD.png": 1710,
	"./antDesign.png": 124,
	"./babel.png": 6949,
	"./bootstrap.png": 7477,
	"./css.png": 4225,
	"./figma.png": 8356,
	"./git.png": 8734,
	"./gitHub.png": 9689,
	"./gitLab.png": 546,
	"./googleAnalytics.png": 8343,
	"./graphql.png": 1183,
	"./html.png": 2320,
	"./jira.png": 3354,
	"./jiraAlign.png": 970,
	"./js.png": 8203,
	"./materialUI.png": 6951,
	"./next.png": 2652,
	"./nodeJs.png": 5407,
	"./openApi.png": 2887,
	"./postman.png": 4527,
	"./pwa.png": 4096,
	"./react.png": 5871,
	"./reactQuery.png": 3559,
	"./redux.png": 7327,
	"./sass.png": 3380,
	"./sentry.png": 2861,
	"./shadcnUI.png": 7734,
	"./socket.png": 6120,
	"./swagger.png": 5315,
	"./tailwind.png": 1876,
	"./trello.png": 3988,
	"./ts.png": 2754,
	"./typedoc.png": 4301,
	"./vite.png": 7814,
	"./vsCode.png": 1480,
	"./webpack.png": 8766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 342;